import { toRem } from 'shared/helpers';
import styled, { css, keyframes } from 'styled-components';

type PreloaderContainerProps = {
  $pathAnimDuration?: number;
  $height?: number
}

const bouncing = keyframes`
  0% {
    translate: 0 0;
  }
  50% {
    translate: 0 var(--max-translate);
  }
  100% {
    translate: 0 0;
  }
`;

const hideAndShow = keyframes`
  0% {
    scale: 0;
  }
  25% {
    scale: 0;
  }
  50% {
    scale: 0;
  }
  75% {
    scale: 0;
  }
  100% {
    scale: 1;
  }
`

export const PreloaderContainer = styled.div<PreloaderContainerProps>`
	height: ${props => props.$height ? toRem(props.$height) : '100dvh'};
	display: flex;
	justify-content: center;
	align-items: center;
  --max-translate: ${props => props.$height ? toRem((props.$height / 100) * -5) : '-5dvh'};
  --global-anim-delay: 0s;
  --path-anim-duration: ${props => `${props.$pathAnimDuration || 2}s`};

  img, svg {
    animation: ${bouncing} 5s ease-in-out infinite;
    animation-delay: var(--global-anim-delay);
    ${props => props.$height && css`
      max-height: ${toRem(props.$height - 30)};
      max-width: calc(100% - ${toRem(30)});
    `}
  }

  &:has(svg) {
    --global-anim-delay: calc(var(--path-anim-duration) + 1s);
  }

  path {
    scale: 0;
    animation: ${hideAndShow} var(--path-anim-duration) ease-in-out forwards;

    &.bottom-left {
      transform-origin: 20% 70%;
    }
    &.bottom-right {
      transform-origin: 60% 70%;
      animation-delay: calc((var(--path-anim-duration) / 4) * 1);
    }
    &.top-left {
      transform-origin: 40% 30%;
      animation-delay: calc((var(--path-anim-duration) / 4) * 2);
    }
    &.top-right {
      transform-origin: 80% 30%;
      animation-delay: calc((var(--path-anim-duration) / 4) * 3);
    }
  }
`;

